import { AxArtwork } from "@dynata/axiom3";
import unavailableImage from "@dynata/axiom3-images/png/general_stand.png";

// AudiencesZeroState component to display when there are no audiences
export function AudiencesZeroState() {
  return (
    <AxArtwork
      title="No audiences"
      image={unavailableImage}
      description="Sorry, this project has no audiences."
    />
  );
}
